import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  components: {
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginBottom: 32,
          marginLeft: 0,
          marginRight: 0,
          display: 'flex',
          alignItems: 'center',
          gap: 20,
          '@media (min-width: 600px)': {
            marginBottom: 80,
          },
          '@media (min-width: 1280px)': {
            marginLeft: 104,
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          padding: 0,
          borderRadius: 4,
          color: '#D70000',
          width: 24,
          height: 24,
          '&.Mui-checked': {
            color: '#D70000',
          },
        },
      },
    },
  },
});

export default theme;
